import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { state } from './state'

export const shopStore = {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/store/shop/index.js